<template>
  <svg
    :width="props.size"
    :height="props.size"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.5 16.5H1.5V15H16.5V16.5ZM7.5 1.5H5.25V13.5H7.5V1.5ZM12.75 6H10.5V13.5H12.75V6Z"
      :fill="color"
    />
  </svg>
</template>

<script setup lang="ts">
  const props = defineProps({
    color: {
      type: String,
      default: '#0000FF',
    },
    size: {
      type: Number,
      default: 18,
    },
  })
</script>
